import React from "react";
import JsonLdGeneric from "../JsonLdGeneric";

/**
 * Returns a component that adds a JSON-LD tag of type LiquorStore.
 * Includes aggregateRating for Google rich results.
 * Data from here - https://www.google.com/storepages?q=goodpairdays.com&c=AU#reviews
 * @returns {Component}
 * */
const JsonLdLiquorStore = () => {
  const structuredLiquorStoreJsonLdData = {
    "@context": "https://schema.org/",
    "@type": "LiquorStore",
    "@id": "https://goodpairdays.com/",
    name: "Good Pair Days",
    url: "https://goodpairdays.com/",
    image: ["https://goodpairdays.com/social-media-preview.jpg"],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5.0",
      bestRating: "5",
      worstRating: "4",
      ratingCount: "3129",
    },
  };

  return <JsonLdGeneric jsonData={structuredLiquorStoreJsonLdData} />;
};

export default JsonLdLiquorStore;
